'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, useEffect, useMemo, useState } from 'react';
import { Typography } from '@/components/shared/Typography';
import { ScrollSmoother, ScrollTrigger } from '@/lib/gsap';
import css from './style.module.scss';
interface Heading {
  id: string;
  text: string;
}
interface Props {
  headings: Heading[];
}
const TableOfContents: FC<Props> = t0 => {
  const $ = _c(19);
  const {
    headings
  } = t0;
  const [activeId, setActiveId] = useState("");
  let t1;
  if ($[0] !== activeId) {
    t1 = t2 => {
      const {
        id
      } = t2;
      return id === activeId;
    };
    $[0] = activeId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeIndex = headings.findIndex(t1);
  const progress = headings.length > 1 && activeIndex >= 0 ? (activeIndex + 1) / headings.length * 100 : 0;
  let t2;
  let t3;
  if ($[2] !== headings) {
    t2 = () => {
      if (!headings.length) {
        return;
      }
      const firstExistingHeading = headings.find(_temp);
      if (firstExistingHeading) {
        setActiveId(firstExistingHeading.id);
      }
      const triggers = headings.flatMap(t4 => {
        const {
          id: id_1
        } = t4;
        const el = document.getElementById(id_1);
        if (!el) {
          return [];
        }
        return [ScrollTrigger.create({
          trigger: el,
          start: "top 30%",
          end: "bottom 30%",
          onEnter: () => setActiveId(id_1),
          onEnterBack: () => setActiveId(id_1)
        })];
      });
      return () => triggers.forEach(_temp2);
    };
    t3 = [headings];
    $[2] = headings;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!headings.length) {
    return null;
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography variant="body-l" tag="p" responsive={false} className={css.title}>Table of contents</Typography>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={css.progressTrack} aria-hidden="true" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `${progress}%`;
  let t7;
  if ($[7] !== t6) {
    t7 = <span className={css.progressLine} style={{
      height: t6
    }} aria-hidden="true" />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== activeId || $[10] !== headings) {
    let t9;
    if ($[12] !== activeId) {
      t9 = t10 => {
        const {
          id: id_2,
          text
        } = t10;
        const isActive = activeId === id_2;
        return <li key={id_2} className={css.item}><a href={`#${id_2}`} className={isActive ? css.linkActive : css.link} onClick={e => {
            e.preventDefault();
            const el_0 = document.getElementById(id_2);
            if (el_0) {
              ScrollSmoother.get()?.scrollTo(el_0, true, "top 100px");
              setActiveId(id_2);
            }
          }}><Typography variant="body-m" tag="span">{text}</Typography></a></li>;
      };
      $[12] = activeId;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    t8 = headings.map(t9);
    $[9] = activeId;
    $[10] = headings;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <ul className={css.list}>{t8}</ul>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <nav className={css.toc}>{t4}<div className={css.listWrapper}>{t5}{t7}{t9}</div></nav>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default TableOfContents;
function _temp(t0) {
  const {
    id: id_0
  } = t0;
  return document.getElementById(id_0);
}
function _temp2(trigger) {
  return trigger.kill();
}